import React from "react";
import { Box, Typography } from "@material-ui/core";
import { i18n } from "../../translate/i18n";

export default function AiHistoryApiDocs() {
  const t = key => i18n.t(`aiHistoryApi.${key}`);
  const example = { companyId: 101, contextRef: "<current-historyAccess.contextRef>", scope: "current_ticket", limit: 20 };
  return <Box mt={2} mb={2}>
    <Typography variant="subtitle2">{t("title")}</Typography>
    <Typography variant="body2">{t("purpose")}</Typography>
    <Typography component="code">POST /ai/internal-skills/talk_query_history</Typography>
    <Typography variant="body2">{t("auth")}</Typography>
    <Typography variant="body2">{t("fields")}</Typography>
    <Box component="pre" style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{JSON.stringify(example, null, 2)}</Box>
    <Box component="pre" style={{ whiteSpace: "pre-wrap", overflowWrap: "anywhere" }}>{[
      "curl -X POST 'https://<talk-host>/ai/internal-skills/talk_query_history'",
      "  -H 'Content-Type: application/json'",
      "  -H 'X-Flowch-Skill-Key: <tenant-skill-secret>'",
      `  --data '${JSON.stringify(example)}'`
    ].join(" \\\n")}</Box>
    <Typography variant="body2">{t("response")}</Typography>
    <Box component="pre" style={{ whiteSpace: "pre-wrap" }}>{JSON.stringify({ ok: true, skillName: "talk_query_history", ticketId: 201,
      result: { status: "ok", scope: "current_ticket", messages: [], nextCursor: null, hasMore: false, truncated: false, remainingCalls: 1 } }, null, 2)}</Box>
    <Typography variant="body2">{t("errors")}</Typography>
    <Typography variant="body2" color="textSecondary">{t("validation")}</Typography>
  </Box>;
}
